import styled from 'styled-components';

const LanguageSwitcherWrapper = styled.div`
  .ant-select-selector {
    padding: 2px 7px 0 !important;
  }

  .ant-select-selector {
    background: none !important;
    border: none !important;
    box-shadow: none !important;
  }

  .ant-select-selector:focus {
    background: none !important;
    border: none !important;
    box-shadow: none !important;
  }
`;

export default LanguageSwitcherWrapper;
